import React, {ForwardRefRenderFunction, FunctionComponent, Ref, useContext} from 'react';
import {ThemeContext} from "../../../context/ThemeContext";
import {Theme} from "../../../models/theme.model";
import styled from "styled-components";
import "./Input.scss";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    isValid?: boolean;
    ref?: Ref<HTMLInputElement>;
}

const StyledInput = styled.input`
      &&& {
        border-color: ${props => props.theme.branding_color}
      }
`;

export const Input = React.forwardRef<ForwardRefRenderFunction<HTMLInputElement>, InputProps>((props, ref: any) => {
        const theme: Theme = useContext(ThemeContext).theme;
        const {isValid, ...inputProps} = props

        return (
            <StyledInput theme={theme} ref={ref} {...inputProps} className={'input'}/>
        );
    }
)